// Portuguese translations for Atomic CRM
// This file extends ra-language-portuguese with custom translations
// @ts-ignore - ra-language-portuguese doesn't have TypeScript definitions
import portugueseMessages from "ra-language-portuguese";
import { mergeTranslations } from "ra-core";

// Portuguese translations for Supabase
const raSupabasePortugueseMessages = {
  "ra-supabase": {
    auth: {
      email: "E-mail",
      sign_in: "Entrar",
      sign_in_with: "Entrar com %{provider}",
      sign_up: "Criar conta",
      password_reset: "Link de redefinição de senha enviado por e-mail.",
      email_label: "E-mail",
      password_label: "Senha",
      confirm_password: "Confirmar senha",
      forgot_password: "Esqueceu a senha?",
      reset_password: "Redefinir senha",
      back_to_login: "Voltar ao login",
      missing_tokens: "Link incompleto: tokens de acesso ausentes.",
    },
    reset_password: {
      forgot_password: "Esqueceu a senha?",
      forgot_password_details: "Informe o e-mail para receber o link de redefinição.",
    },
    set_password: {
      new_password: "Definição de senha",
    },
    validation: {
      password_mismatch: "As senhas não coincidem",
    },
  },
};

// O ra-language-portuguese não traduz `ra.auth.email` nem `ra.auth.confirm_password`
// (ele só tem `username`), então as telas de login, de pedir link e de escolher
// senha apareciam com "Email" e "Confirm password" no meio do português.
const raAuthPortugueseMessages = {
  ra: {
    auth: {
      email: "E-mail",
      confirm_password: "Confirmar senha",
    },
  },
};

// Custom Portuguese translations for Atomic CRM resources
const customPortugueseMessages = {
  resources: {
    contacts: {
      name: "Contato |||| Contatos",
      fields: {
        name: "Nome",
        gender: "Gênero",
        title: "Cargo",
        company: "Empresa",
        company_id: "Empresa",
        email: "E-mail",
        phone: "Telefone",
        background: "Informações (bio, como se conheceram, etc)",
        avatar: "Avatar",
        first_seen: "Primeiro Contato",
        last_seen: "Último Contato",
        has_newsletter: "Recebe Newsletter",
        status: "Status",
        tags: "Tags",
        city: "Cidade",
        state: "Estado",
      },
    },
    companies: {
      name: "Empresa |||| Empresas",
      fields: {
        name: "Nome",
        sector: "Setor",
        size: "Tamanho",
        website: "Website",
        logo: "Logo",
        address: "Endereço",
        city: "Cidade",
        zipcode: "CEP",
        state: "Estado",
        country: "País",
        phone_number: "Telefone",
        user_id: "Vendedor",
      },
    },
    deals: {
      name: "Lead |||| Leads",
      fields: {
        name: "Nome",
        description: "Descrição",
        amount: "Orçamento",
        stage: "Estágio",
        category: "Categoria",
        expected_closing_date: "Data Prevista de Fechamento",
        company_id: "Empresa",
        contact_ids: "Contatos",
        user_id: "Vendedor",
        index: "Índice",
        created_at: "Criado em",
        updated_at: "Atualizado em",
      },
    },
    sales: {
      name: "Vendedor |||| Vendedores",
      fields: {
        name: "Nome",
        email: "E-mail",
        administrator: "Administrador",
        disabled: "Desabilitado",
        avatar: "Avatar",
      },
    },
    tasks: {
      name: "Tarefa |||| Tarefas",
      fields: {
        text: "Descrição",
        type: "Tipo",
        due_date: "Data de Vencimento",
        contact_id: "Contato",
        user_id: "Vendedor",
        done_date: "Data de Conclusão",
      },
    },
    contactNotes: {
      name: "Nota |||| Notas",
      fields: {
        text: "Texto",
        date: "Data",
        status: "Status",
        contact_id: "Contato",
        user_id: "Vendedor",
      },
    },
    dealNotes: {
      name: "Nota |||| Notas",
      fields: {
        text: "Texto",
        date: "Data",
        deal_id: "Negócio",
        user_id: "Vendedor",
      },
    },
  },
  ra: {
    page: {
      dashboard: "Dashboard",
    },
    sort: {
      sort_by: "Ordenar por %{field} %{order}",
      ASC: "crescente",
      DESC: "decrescente",
    },
  },
  // Custom UI labels (hardcoded strings in components)
  atomic: {
    header: {
      leads: "Leads",
      dashboard: "Dashboard",
      contacts: "Contatos",
      companies: "Empresas",
      deals: "Funil de Vendas",
      users: "Usuários",
      myInfo: "Minhas Informações",
    },
    dashboard: {
      stepper: {
        title: "Próximos Passos",
        progress: "concluído",
        step1: "Logar na plataforma North",
        step2: "Adicione seu primeiro contato",
        step3: "Adicione sua primeira nota",
        newContact: "Novo Contato",
        addNote: "Adicionar nota",
        description: "Vá para uma página de contato e adicione uma nota",
      },
      hotContacts: "Contatos Quentes",
      createContact: "Criar contato",
      hotContactsEmpty: 'Contatos com status "quente" aparecerão aqui.',
      hotContactsHelp:
        'Altere o status de um contato adicionando uma nota a esse contato e clicando em "mostrar opções".',
      upcomingTasks: "Próximas Tarefas",
      tasks: {
        overdue: "Atrasadas",
        today: "Hoje",
        tomorrow: "Amanhã",
        thisWeek: "Esta semana",
        later: "Mais tarde",
      },
      loadMore: "Carregar mais",
      tasksEmpty: "Tarefas adicionadas aos seus contatos aparecerão aqui.",
      upcomingDealRevenue: "Receita Futura de Negócios",
      latestActivity: "Atividade Recente",
      chart: {
        won: "Ganho",
        lost: "Perdido",
      },
    },
    contacts: {
      import: "Importar",
      newContact: "Novo contato",
      editContact: "Editar contato",
      showContact: "Ver contato",
      createContact: "Criar contato",
      createLeadTitle: "Criar um lead para este contato?",
      createLeadDescription: "Deseja adicionar um novo lead para este contato agora?",
      skipDeal: "Pular",
      noContactsFound: "Nenhum contato encontrado",
      emptyList: "Nenhum contato cadastrado.",
      emailAddresses: "Endereços de E-mail",
      phoneNumbers: "Números de Telefone",
      contactPreference: "Preferência de Contato",
      maritalStatus: "Estado Civil",
      backgroundInfo: "Informações (bio, como se conheceram, etc)",
      accountManager: "Gerente de Conta",
      searchPlaceholder: "Buscar nome, empresa...",
      filters: {
        lastActivity: "Última atividade",
        today: "Hoje",
        thisWeek: "Esta semana",
        beforeThisWeek: "Antes desta semana",
        beforeThisMonth: "Antes deste mês",
        beforeLastMonth: "Antes do mês passado",
        status: "Status",
        tags: "Tags",
        tasks: "Tarefas",
        accountManager: "Responsável",
        withPendingTasks: "Com tarefas pendentes",
      },
      import_dialog: {
        title: "Importar",
        csvFile: "Arquivo CSV",
        importButton: "Importar",
        close: "Fechar",
        downloadSample: "Baixar CSV de exemplo",
        sampleDescription:
          "Arquivo CSV de exemplo para uso como modelo.",
        running:
          "Importação em andamento. Mantenha esta aba aberta.",
        imported: "Importado",
        contacts: "contatos",
        with: "com",
        errors: "erros",
        estimatedTime: "Tempo estimado restante:",
        stopImport: "Parar importação",
        error:
          "Não foi possível importar o arquivo. Verifique se é um CSV válido.",
        complete: "Importação de contatos concluída. Importado",
        completeErrors: "erros",
      },
      lastActivity: "última atividade",
      lastActivityOn: "Última atividade em",
      followedBy: "Acompanhado por",
      ago: "atrás",
      identity: "Identidade",
      position: "Posição",
      personalInfo: "Informações pessoais",
      status: {
        cold: "Frio",
        warm: "Morno",
        hot: "Quente",
        inContract: "Em contrato",
      },
      gender: {
        male: "Masculino",
        female: "Feminino",
      },
    },
    companies: {
      newCompany: "Nova Empresa",
      editCompany: "Editar Empresa",
      showCompany: "Mostrar Empresa",
      createCompany: "Criar Empresa",
      accountManager: "Responsável",
      addContact: "Adicionar contato",
      noCompaniesFound: "Nenhuma empresa encontrada",
      emptyList: "Parece que sua lista de empresas está vazia",
      contact: "Contato",
      address: "Endereço",
      context: "Contexto",
      additionalInformation: "Informações adicionais",
      companyNamePlaceholder: "Nome da empresa",
      description: "Descrição",
      contextLinks: "Links de contexto",
      filters: {
        size: "Tamanho",
        sector: "Setor",
        accountManager: "Responsável",
      },
      autocomplete: {
        createItem: "Criar %{item}",
      },
    },
    deals: {
      newDeal: "Novo lead",
      createDeal: "Criar lead",
      createNewContact: "Criar novo contato",
      noDealsFound: "Nenhum lead encontrado",
      emptyList: "Nenhum lead cadastrado.",
      addFirstContact: "Cadastre um contato",
      beforeCreatingDeal: "antes de criar um lead.",
      dealName: "Nome do lead",
      contacts: "Contatos",
      category: "Categoria",
      linkedTo: "Vinculado a",
      misc: "Diversos",
      expectedClosingDate: "Data de fechamento prevista",
      budget: "Orçamento",
      stage: "Estágio",
      productPurchased: "Produto Comprado",
      isRenewal: "É renovação",
      renewalDate: "Data de renovação",
      productsPurchased: "Produtos Comprados",
      purchased: "Comprado",
      deals: "Leads",
      past: "Passado",
      archive: "Arquivar",
      archivedDeal: "Lead arquivado",
      sendBackToBoard: "Enviar de volta ao quadro",
      dealArchived: "Lead arquivado",
      errorDealNotArchived: "Não foi possível arquivar o lead.",
      dealUnarchived: "Lead desarquivado",
      errorDealNotUnarchived: "Não foi possível desarquivar o lead.",
      editDeal: "Editar lead",
      backToDeal: "Voltar ao lead",
      companyPlaceholder: "Empresa",
      onlyMyLeads: "Apenas meus leads",
      stages: {
        opportunity: "Oportunidade",
        proposalSent: "Proposta Enviada",
        inNegotiation: "Em Negociação",
        won: "Ganho",
        lost: "Perdido",
        delayed: "Adiado",
      },
    },
    sales: {
      newUser: "Novo usuário",
      userCreatedNotification: "Usuário criado. E-mail para definição de senha a caminho.",
      userCreationError: "Ocorreu um erro ao criar o usuário.",
    },
    tasks: {
      description: "Descrição",
      contact: "Contato",
      save: "Salvar",
      taskActions: "ações da tarefa",
      createTask: "Criar nova tarefa",
      createTaskFor: "Criar nova tarefa para",
      due: "vence em",
      types: {
        none: "Nenhum",
        email: "E-mail",
        demo: "Demonstração",
        lunch: "Almoço",
        meeting: "Reunião",
        followUp: "Acompanhamento",
        thankYou: "Agradecimento",
        ship: "Envio",
        call: "Chamada",
      },
    },
    notes: {
      addNote: "Adicionar esta nota",
      date: "Data",
      addNotePlaceholder: "Adicionar uma nota",
      showOptions: "Mostrar opções",
      attachFilesOrChangeDetails: "(anexar arquivos ou alterar detalhes)",
      addedNote: "adicionou uma nota",
      attachments: "Anexos",
    },
    activity: {
      loadMore: "Carregar mais atividade",
      addedCompany: "adicionou empresa",
      added: "adicionou",
      toCompany: "à empresa",
      addedNoteAbout: "adicionou uma nota sobre",
      userId: "ID do usuário",
      addedDeal: "adicionou negócio",
      addedNoteAboutDeal: "adicionou uma nota sobre negócio",
      at: "em",
    },
    settings: {
      myInfo: "Minhas informações",
      change: "Alterar",
      firstName: "Nome",
      lastName: "Sobrenome",
      email: "E-mail",
      changePassword: "Alterar senha",
      passwordResetEmailSent: "E-mail de redefinição de senha enviado.",
      passwordResetError: "Não foi possível enviar o e-mail de redefinição de senha.",
      edit: "Editar",
      cancel: "Cancelar",
      save: "Salvar",
      inboundEmail: "E-mail de entrada",
      inboundEmailDescription:
        "E-mails enviados ao endereço de entrada (por exemplo, em Cc:) viram notas nos contatos correspondentes.",
    },
    image: {
      uploadAndResize: "Enviar e redimensionar imagem",
      dropOrClick: "Solte um arquivo aqui ou clique para selecionar.",
      updateImage: "Atualizar imagem",
    },
  },
};

// Merge all Portuguese translations
export default mergeTranslations(
  portugueseMessages,
  raAuthPortugueseMessages,
  raSupabasePortugueseMessages,
  customPortugueseMessages,
);
